import type { CSSProperties } from "react";

export type TableSort<Key extends string = string> = { key: Key; direction: "asc" | "desc" };

export function SortHeading<Key extends string>({
  column,
  label,
  sort,
  onSort,
  style,
}: {
  column: Key;
  label: string;
  sort: TableSort<Key> | null;
  onSort: (column: Key) => void;
  style?: CSSProperties;
}) {
  const active = sort?.key === column;
  return (
    <button
      type="button"
      aria-label={`Sort by ${label}`}
      title={`Sort by ${label}`}
      className={
        active
          ? "font-semibold text-foreground"
          : "font-medium text-muted-foreground hover:text-foreground"
      }
      style={style}
      onClick={() => onSort(column)}
    >
      {label} {active ? (sort?.direction === "asc" ? "↑" : "↓") : ""}
    </button>
  );
}

export function compareNullableSortValues(
  leftValue: unknown,
  rightValue: unknown,
  direction: "asc" | "desc",
): number {
  const leftMissing = leftValue === null || leftValue === undefined;
  const rightMissing = rightValue === null || rightValue === undefined;
  if (leftMissing && rightMissing) return 0;
  if (leftMissing) return 1;
  if (rightMissing) return -1;
  const multiplier = direction === "asc" ? 1 : -1;
  if (typeof leftValue === "string") {
    return leftValue.localeCompare(String(rightValue)) * multiplier;
  }
  return (Number(leftValue) - Number(rightValue)) * multiplier;
}
